import React, { useState } from "react";
import { ArrowRight, Check, Lock } from "lucide-react";
import { practiceApi } from "../lib/practiceApi";
import "./login.css";

export default function ResetPasswordPage() {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(event) {
    event.preventDefault();
    setError("");
    if (password.length < 8) return setError("La password deve avere almeno 8 caratteri");
    if (password !== confirm) return setError("Le due password non coincidono");
    setBusy(true);
    try {
      await practiceApi("/auth/reset-password", { method: "POST", body: JSON.stringify({ token, password }) });
      setDone(true);
    } catch (err) { setError(err.message); } finally { setBusy(false); }
  }

  return <main className="legal-page" data-testid="reset-password-page">
    <img src="/brand/ingego-logo.png" alt="ingego" />
    {done
      ? <>
        <h1 style={{ display: "flex", alignItems: "center", gap: 12 }}><Check size={26} color="#2F7D5B" />Password aggiornata</h1>
        <p>Da ora accedi con la nuova password. Per sicurezza le sessioni aperte sono state chiuse.</p>
        <a className="legal-back" href="/" data-testid="reset-go-login">Vai all'accesso <ArrowRight size={15} /></a>
      </>
      : <>
        <h1>Scegli una nuova password</h1>
        <p>Il collegamento è personale e vale una sola volta. Usa almeno 8 caratteri.</p>
        <form onSubmit={submit} style={{ maxWidth: 380, marginTop: 24 }}>
          <label className="login-field">Nuova password
            <span className="login-input"><Lock size={17} />
              <input type="password" data-testid="reset-password-input" autoComplete="new-password"
                value={password} onChange={e => setPassword(e.target.value)} />
            </span>
          </label>
          <label className="login-field">Conferma password
            <span className="login-input"><Lock size={17} />
              <input type="password" data-testid="reset-confirm-input" autoComplete="new-password"
                value={confirm} onChange={e => setConfirm(e.target.value)} />
            </span>
          </label>
          {error && <div className="error" data-testid="reset-error" style={{ marginTop: 14 }}>{error}</div>}
          <button className="primary login-submit" disabled={busy || !token} data-testid="reset-submit">
            {busy ? "Salvataggio…" : "Salva la nuova password"}
          </button>
          {!token && <p className="muted" style={{ marginTop: 12, fontSize: 12.5 }}>Collegamento incompleto: riparti da "Password dimenticata?" nella pagina di accesso.</p>}
        </form>
      </>}
  </main>;
}
